<template>
  <validation-provider
    v-slot="{ errors }"
    mode="eager"
    :name="tag.description"
    :rules="tag.custom_settings.validation || ''"
  >
    <div class="pb-4">
      <v-text-field
        :id="`form-video-editor-${tag.name}`"
        :value="storageFix"
        :label="tag.description"
        outlined
        readonly
        dense
        clearable
        class="fm-text-field"
        :hide-details="errors.length == 0"
        :error-messages="errors"
        @click="fmOpen"
        @click:clear="fmReset"
      >
        <template v-slot:append>
          <div class="d-flex">
            <v-icon @click="fmOpen">mdi-image-search-outline</v-icon>
            <uploader-button
              :work-dir="workDir"
              class="d-block"
              @upload-success="onImageUpload"
              @upload-error="onUploadError"
            >
              <v-icon>mdi-upload</v-icon>
            </uploader-button>
          </div>
        </template>
      </v-text-field>
      <video v-if="hasVideo" autoplay muted loop style="max-width: 100%">
        <source :src="fullVideoPath" type="video/mp4" />
      </video>
      <file-manager-dialog
        v-model="fmDialog"
        src="videoeditor"
        :selected-path="storageFix"
        :work-dir="workDir"
        :allowed-extensions="['mp4', 'mov']"
        @fm-select="fmSelect"
        @fm-close="fmClose"
      />
    </div>
  </validation-provider>
</template>

<script>
import UploaderButton from "@/components/UploaderButton.vue";
import FileManagerDialog from "./FileManagerDialog/FileManagerDialog.vue";

export default {
  components: {
    FileManagerDialog,
    UploaderButton
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    tag: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fmDialog: false
    };
  },
  computed: {
    storageFix() {
      return this.value ? this.value.replace("<STORAGE>", "") : "";
    },
    workDir() {
      return this.tag?.custom_settings?.images_dir || "/video";
    },
    hasVideo() {
      return this.value && this.value.length > 0;
    },
    fullVideoPath() {
      return this.value
        ? this.value.replace("<STORAGE>", this.$store.getters.getStoragePrefix)
        : "";
    }
  },

  methods: {
    fmOpen() {
      this.fmDialog = true;
    },
    fmClose() {
      this.fmDialog = false;
    },
    fmReset() {
      this.$emit("input", "");
    },
    fmSelect(file) {
      this.fmDialog = false;
      let newValue = file;
      if (!newValue.startsWith("/")) newValue = `/${newValue}`;
      this.$emit("input", `<STORAGE>${newValue}`);
    },
    onImageUpload(files) {
      let newValue = files[0];
      if (!newValue.startsWith("/")) newValue = `/${newValue}`;
      this.$emit("input", `<STORAGE>${newValue}`);
    },
    onUploadError(error) {
      this.$store.commit("addNotice", {
        type: "error",
        message: error
      });
    }
  }
};
</script>
